import { ChevronDownIcon } from '../../../../../assets/icons/common';
import styles from './style.module.scss';

interface Props {
    number: number;
    showMore: boolean;
    examples: string[];
    description: string;
    onToggleShowMore: () => void;
};

/** The question and its examples, collapsible so the editor can take the screen. */
function QuestionPanel(props: Props) {
    const {
        number,
        showMore,
        examples,
        description,
        onToggleShowMore,
    } = props;

    return (
        <div className={styles.question}>
            <p><b>Question {number}: </b>{description}</p>
            {examples.map((example, index) =>
                <div className={styles.example} key={index}>
                    <span className={styles.example_title}>
                        Example {index + 1}:
                    </span>
                    <p>{example}</p>
                </div>)}
            <div className={styles.actions}>
                <div
                    data-show-more={showMore}
                    onClick={onToggleShowMore}
                    className={styles.show_more}
                >
                    <span>{showMore ? 'Less' : 'More'}</span>
                    <ChevronDownIcon stroke='#FFFFFF' />
                </div>
            </div>
        </div>
    )
};

export default QuestionPanel;
